import styled from 'styled-components'

export const StyledStudentTags = styled.ul`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
`
